import React, { useEffect } from "react"
import { CardDetail, EmptyCard, Text2Row } from "../../../../../../component/index.jsx"
import { useDispatch, useSelector } from "react-redux"
import { getQaActivityList } from "../../../../../../redux/actions/AreaAction.jsx"
import { useTranslation } from "react-i18next"
import { RowModule } from "../../../../../../component/atoms/RowModule/RowModule.jsx"
import { DATE_TYPE_ENUM } from "../../../../../../constants/StringConstant.js"
import {
  checkActivityIcon,
  checkActivityName,
  checkStatus,
  stringFormatting
} from "../../../../../helpers/TextHelper.js"
import { timeStampToDate } from "../../../../../helpers/DateHelper.js"
import { Skeleton } from "@material-ui/lab"
import { useHistory } from "react-router-dom"
import { RoutesConstants } from "../../../../../../constants/RoutesConstants.js"

export const QaInspectionTab = ({ id, status }) => {
  const dispatch = useDispatch()
  const history = useHistory()
  const { t } = useTranslation()
  const { Area, General } = useSelector((state) => state)

  useEffect(() => {
    dispatch(getQaActivityList(id))
  }, [])

  const text2Row = (item) => {
    return (
      <>
        <Text2Row
          title={`${t("label_inspection_date")}:`}
          description={timeStampToDate(
            stringFormatting(item?.activity_date),
            DATE_TYPE_ENUM.ISO_DATE_STRAP
          )}
        />
        <Text2Row
          title={`${t("label_hst")}:`}
          description={stringFormatting(item?.hst, "HST", true)}
        />
        <Text2Row
          title={`${t("label_inspected_by")}:`}
          description={stringFormatting(item?.created_by)}
        />
        <Text2Row
          title={`${t("label_created_date")}:`}
          description={timeStampToDate(
            stringFormatting(item?.created_date),
            DATE_TYPE_ENUM.ISO_DATETIME_STRAP
          )}
        />
        <div className={"d-flex justify-content-end"}>
          {General.loading ? (
            <Skeleton animation="wave" variant={"text"} width={100} />
          ) : (
            <button
              className={"btn btn-outline-primary mx-4"}
              onClick={() => {
                history.push(RoutesConstants.AREA.DETAIL_QA_INSPECTION(status, id, item?.id))
              }}>
              {t("button_see_detail")}
            </button>
          )}
        </div>
      </>
    )
  }

  const titleCardDetail = (item) => {
    return (
      <div className={"d-flex align-items-center w-100  justify-content-between"}>
        <div>{t(checkActivityName(item?.activity_enum))}</div>
        {checkStatus(item?.activity_status_enum)}
      </div>
    )
  }

  return (
    <>
      {!General.loading && Area?.listInspection?.length === 0 ? (
        <EmptyCard bodyCustom={<h6 className={"mt-12"}>{t("no_qa_activity")}</h6>} />
      ) : (
        Area.listInspection?.map((item, index) => {
          return (
            <RowModule key={index}>
              <CardDetail
                titleClassName={"w-100"}
                titleCardDetail={titleCardDetail(item)}
                flatIconAndText2Rows={text2Row(item)}
                svgImage={checkActivityIcon(item?.activity_enum)}
              />
            </RowModule>
          )
        })
      )}
    </>
  )
}